import { Link } from "react-router-dom";
import styled from "styled-components";

// This is a general Component
export const AppContainer = styled.div`
  width: 100%;
  padding-top: 8vh;
  padding-bottom: 4px;
  height: 94vh;
  // overflow-y: auto;
`;

export const AppInnerContainer = styled.div`
  margin-left: auto;
  margin-right: auto;
  width: 75%;
  padding-bottom: 4px;
  height: 100%;

  @media (min-width: 1024px) {
    width: 80%;
  }

  @media (max-width: 640px) {
    width: 95%;
    padding-right: 1rem;
    padding-left: 1rem;
    font-size: 14px;
  }
`;

export const CustomLink = styled(Link)`
  &:hover {
    background: ${(props) => props.bg};
  }
`;

export const ArticlesTitleLink = styled(Link)`
  margin-top: 8px;
  margin-bottom: 8px;
  font-size: 20px;
  color: #3c6ebe;
`;

export const Destacados = styled(Link)`
  display: flex;
  margin-top: 0.5rem;
  gap: 8px;
  align-items: center;
  color: black;
  font-weight: lighter;

  &:hover {
    color: #3c6ebe;
    text-decoration: underline;
  }

  /* className="my-1 flex gap-2 items-center" */
`;

export const HomeSearch = styled.input`
  width: 100%;
  border-radius: 10px;
  border: 1px solid #dce6e6;

  &:focus {
    border-color: #dce6e6;
  }
`;
